import styled from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

import { Container as ContainerOrig } from '~/src/features/movix-new/VideoServices/styled';

export const HeaderMainText = styled.div`
    max-width: 550px;
    ${FONTS.H1};
    color: ${COLORS.TextWhite};
    margin-top: 25px;

    @media (max-width: ${wideBreakpoints.sDesktop}) {
        max-width: 400px;
    }

    @media (max-width: ${wideBreakpoints.tablet}) {
        text-align: start;
        ${FONTS.H3};
    }
`;

export const SubText = styled(HeaderMainText)`
    ${FONTS.XS};
   width: 475px;
   margin-top: 0;
`;

export const Container = styled(ContainerOrig)`

    @media (max-width: ${wideBreakpoints.tablet}) {
        margin: 0 34px;
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        max-width: inherit;
        padding: 0;
        margin: 0 16px;
    }
`;

export const ButtonBlock = styled.div`
    display: block;
    width: 236px;
    height: 48px;
    margin-top: 32px;

    @media (max-width: ${wideBreakpoints.tablet}) {
        margin-top: 24px;
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        width: 100%;
    }
`;

export const HeaderLegal = styled.div`
    width: 480px;
    color: ${COLORS.TextWhite};
    opacity: .75;
    margin-top: 14px;
    ${FONTS.XS};

    @media (max-width: ${wideBreakpoints.sDesktop}) {
        margin-top: 26px;
        ${FONTS.XXS};
    }

    @media (max-width: ${wideBreakpoints.tablet}) {
        ${FONTS.XS};
        margin: 16px 0 45px 0;
        text-align: left;
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        width: 100%;
        ${FONTS.XXS};
        margin: 20px 0 65px 0;
        white-space: normal;
    }
`;

export const WrapperBottomBlock = styled.div`
    width: 100%;

    @media (min-width: 768px) {
        flex-direction: column;
    }
`;
